// src/utils/downloadExistingInvoice.js
import { generateInvoicePdf } from "./generateInvoicePdf";

/**
 * downloadExistingInvoice (prod-ready)
 * - Récupère une facture existante par invoice_id
 * - Auth obligatoire (Bearer token) car endpoint protégé
 * - Génère le PDF et déclenche le download
 *
 * Posture Lead:
 * - Erreurs explicites et actionnables
 * - Pas de "silent fail"
 */
export async function downloadExistingInvoice({ invoiceId }) {
  if (!invoiceId) throw new Error("invoiceId manquant");

  const token = localStorage.getItem("user_token") || "";
  if (!token) {
    // UX: l'utilisateur est probablement déconnecté ou token non stocké
    throw new Error("Session expirée. Merci de vous reconnecter.");
  }

  const res = await fetch(
    `https://marchedeluxe.ch/services/get_invoice.php?invoice_id=${invoiceId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  let full = null;
  try {
    full = await res.json();
  } catch {
    throw new Error("Réponse invalide du serveur (invoice).");
  }

  // Gestion HTTP status explicite (prod-friendly)
  if (res.status === 401) {
    throw new Error("Session expirée. Merci de vous reconnecter.");
  }
  if (res.status === 403) {
    throw new Error("Accès refusé à cette facture.");
  }
  if (!res.ok || !full?.success) {
    throw new Error(full?.error || "Impossible de récupérer la facture.");
  }

  const doc = generateInvoicePdf({
    invoice: full.invoice,
    lines: full.lines,
    fees: full.fees,
  });

  const fileName = `${full.invoice?.invoice_number || `MD-${invoiceId}`}.pdf`;
  doc.save(fileName);

  return true;
}
